import {
  Button,
  Logo
} from "ui";

const { default: styled } = require("styled-components");

export const Background = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0,0,0,.7);

  display: ${({ isOpen }) => isOpen ? 'unset' : 'none'};
  visibility: ${({ isOpen }) => isOpen ? 'visible' : 'hidden'};

  ${({theme}) => theme.old.breakpoints.isMobile} {
    display: none;
    visibility: hidden;
  }
`

export const Nav = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  transform: ${({ isOpen }) => isOpen ? 'translateX(0%)' : 'translateX(100%)'};
  width: 400px;
  height: 100dvh;

  padding: 0 16px;
  padding-top: 14px;

  background-color: #18181B;
  transition: ${({ theme }) => theme.old.transition.default };

  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    width: 100vw;
    min-width: 300px;
    padding-top: 20px;
  }
`

export const CloseBtn = styled(Button)`
  background-color: transparent;
  
  :hover {
    background-color: transparent;
    box-shadow: none;
  }

  :active {
    box-shadow: none;
  }
`

export const LogoStyled = styled(Logo)`
  margin-top: -5px; // to align with header logo
`